/**
 * Modal/drawer overlay'lerinde "sürükleyip dışarıda bırakma" kaynaklı kapanmayı engeller.
 *
 * Problem: overlay'ler `onClick={onClose}` (ya da `e.target === e.currentTarget` kontrolü) ile
 * kapanıyor. Kullanıcı input içinde metin seçerken mouse'u basılı tutup overlay üzerinde bıraktığında
 * tarayıcı `click` olayını mousedown/mouseup'ın EN YAKIN ORTAK ATASINDA tetikler — bu da overlay'in
 * kendisidir. Sonuç: seçim yaparken modal kapanıyor, yazılanlar gidiyor.
 *
 * Çözüm: overlay'e giden click yalnızca basma da overlay üzerinde başladıysa geçer. Aksi halde olay
 * capture aşamasında durdurulur; React'in kök konteynerdeki dinleyicisi hiç görmez, dolayısıyla tek
 * tek modal dosyalarına dokunmadan tüm overlay'ler korunur.
 *
 * Kapsam: class listesinde `overlay` ya da `*-overlay` token'ı olan elemanlar (modal-overlay,
 * ocd-overlay, sa-drawer-overlay ...). `modal-overlay-close` gibi buton sınıfları eşleşmez.
 */
const isOverlayElement = (el) => {
    if (!(el instanceof Element)) return false;
    for (const token of el.classList) {
        if (token === 'overlay' || token.endsWith('-overlay')) return true;
    }
    return false;
};

export const installOverlayClickGuard = () => {
    if (typeof document === 'undefined' || document.__overlayClickGuardInstalled) return;
    document.__overlayClickGuardInstalled = true;

    let pressTarget = null;
    const rememberPress = (e) => { pressTarget = e.target; };

    // pointerdown kalem/dokunmatikte de gelir; mousedown ve touchstart geriye uyum içindir.
    document.addEventListener('pointerdown', rememberPress, true);
    document.addEventListener('mousedown', rememberPress, true);
    document.addEventListener('touchstart', rememberPress, true);

    document.addEventListener('click', (e) => {
        if (!isOverlayElement(e.target)) return;
        if (pressTarget === e.target) return; // gerçek overlay tıklaması → kapanmaya izin ver

        e.stopPropagation();
        e.preventDefault();
    }, true);
};
